import styled from 'styled-components';
import CurrencyCellProps from './type';
import Typography from '../../../Typography';

export const CurrencyCellStyled = styled(Typography)<CurrencyCellProps>`
  display: flex;
  justify-content: center;
`;
